/**
 * A11y dialog
 */
var component_a11y_dialog = function(args) {
  let dialog = args.dialog;

  // Instantiate a new A11yDialog module
  dialog = new A11yDialog(dialog);

  dialog.on('show', function (dialogEl, event) {
    dialogEl.classList.add('dialog-visible');
  });

  dialog.on('hide', function (dialogEl, event) {
    dialogEl.classList.remove('dialog-visible');
  });
}
